import { H3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled, { keyframes, css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  border-radius: ${themeStyle.radiusLarge};
  background: ${themeStyle.varBackgroundAlt};
  border: 1px solid ${themeStyle.varInkLight};
  box-shadow: ${themeStyle.varShadowSmallHeavy};
  padding: 48px;
  display: flex;
  gap: 24px;
  margin-bottom: 1px; // Remove any overlap with the current component's bottom border and next component

  flex-direction: column;
  ${QUERIES.largeTabletAndUp} {
    flex-direction: row;
    justify-content: space-between;
  }

  ${H3}:first-letter {
    text-transform: uppercase;
  }
`;

export const ChangeTeamSizeLink = styled.button`
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  font: inherit;
  font-size: ${themeStyle.fontSize14};
  font-weight: ${themeStyle.fontMedium};
  text-decoration: underline;
  color: ${themeStyle.varBrandMain};
  cursor: pointer;

  color: ${themeStyle.varBlueMain};
  text-decoration-line: none;

  &:hover {
    color: ${themeStyle.varBlueMain};
    text-decoration: underline;
  }
`;

const pulse = keyframes`
  50% {
    opacity: .5;
  }
`;

const animationRule = css`
  ${pulse};
`;

export const Skeleton = styled.div`
  background-color: ${themeStyle.varInkLight};
  height: auto;
  transform: scale(1, 0.6);
  border-radius: 4px;
  animation: 2s ease-in-out 0.5s infinite ${animationRule};
  font-size: 1rem;
`;
